enum Endpoints {
  UserVerify = '/lending/file_upload_code',
  FileUpload = '/lending/file_upload_code/upload',
}

export default Endpoints;
